const EDUCATION_LEVEL_LABELS = {
  CERT_I: 'Cert I',
  CERT_II: 'Cert II',
  CERT_III: 'Cert III',
  CERT_IV: 'Cert IV',
  CERTIFICATE: 'Certificate',
  DIPLOMA: 'Diploma',
  ASSOCIATE_DEGREE: 'Associate Degree',
  ADVANCED_DIPLOMA: 'Advanced Diploma',
  BACHELORS: 'Bachelors',
  GRADUATE_CERTIFICATE: 'Graduate Certificate',
  GRADUATE_DIPLOMA: 'Graduate Diploma',
  MASTERS: 'Masters',
  PHD: 'PhD',
};

const BEGINNER = 'BEGINNER';
const INTERMEDIATE = 'INTERMEDIATE';
const ADVANCED = 'ADVANCED';

const proficiencySortValues = {
  [ADVANCED]: 1,
  [INTERMEDIATE]: 2,
  [BEGINNER]: 3,
};

export const mapEducations = educations => (
  educations ? (
    educations.map(education => ({
      ...education,
      levelLabel: EDUCATION_LEVEL_LABELS[education.level.toUpperCase()],
    }))
  ) : educations
);

const sortSkillsByProficiency = skills => (
  skills ? skills.sort((skillDataA, skillDataB) => {
    const unknownValue = 99;
    const proficiencyA = proficiencySortValues[skillDataA.proficiency] || unknownValue;
    const proficiencyB = proficiencySortValues[skillDataB.proficiency] || unknownValue;

    if (proficiencyA < proficiencyB) {
      return -1;
    }
    if (proficiencyA > proficiencyB) {
      return 1;
    }
    return 0;
  }) : skills
);

export const mapShortlistedWeployees = weployees => weployees.map(weployee => ({
  ...weployee,
  educations: mapEducations(weployee.educations),
  systemsKnowledges: sortSkillsByProficiency(weployee.systemsKnowledges),
  technicalSkills: sortSkillsByProficiency(weployee.technicalSkills),
}));

export default {
  mapEducations,
  mapShortlistedWeployees,
};
